module.exports = __webpack_public_path__ + "img/TextIcon.b9ea04f5.svg";